import React from "react";
import logo from "../../assets/logowhite.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  const imgUrl =
    "https://s3.ap-south-1.amazonaws.com/cdn.clapingo.com/clapingoWeb";
  return (
    <>
      <div className=" footer">
        <div className="card">
          <div className="row mb-4">
            <div className="col-md-3 col-sm-3 col-xs-3">
              <div className="footer-text pull-left">
                <img
                  src={logo}
                  className="logo m-3"
                  id="logo1"
                  alt="clapingo_logo"
                />
                <h4 className="text-white">About Us</h4>
                <p className="footer-text text-white">
                  Clapingo is a unique platform where you practise conversations
                  live with various speakers across the country. This is a
                  judgment-free space where people can freely speak with a
                  diverse set of people from different backgrounds.
                </p>
                <div className="social ">
                  <a href="https://www.facebook.com/clapingo/">
                    <i className="fab fa-facebook-f fa-lg"></i>
                  </a>
                  <a href="https://www.instagram.com/clapingo/">
                    <i className="fab fa-instagram fa-lg"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/clapingo/?originalSubdomain=in">
                    <i className="fab fa-linkedin fa-lg"></i>
                  </a>
                  <a href="https://twitter.com/clapingo2020">
                    <i className="fab fa-twitter fa-lg"></i>
                  </a>
                  <a href="https://in.pinterest.com/clapingo/_created/">
                    <i className="fab fa-pinterest fa-lg"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-xs-3 mt-4">
              <h5 className="heading">Reach Us</h5>
              <ul>
                <li className="footer-text">Email: info@clapingo.com</li>
                <li className='footer-text'>DLF Capital Greens,<br/>Shivaji Marg, New Delhi-110015</li>
              </ul>
            </div>

            <div className="col-md-3 col-sm-3 col-xs-3 mt-4">
              <h5 className="heading">Quick Links</h5>
              <ul className="card-text">
                <li className="footer-text">
                  <Link to="/affiliate">Affiliate</Link>
                </li>
                <li className="footer-text">
                  <Link to="/teach-with-us">Teach With Us</Link>
                </li>
                <li className="footer-text">
                  <a href="https://clapingo.com/blog/">Blog</a>
                </li>
                <li className="footer-text">
                  <Link to="/plans">Subscribe</Link>
                </li>
                <li className="footer-text">
                  <a
                    href="https://clapngobucket.s3.amazonaws.com/documents/misc/Clapingo+Terms+and+Conditions+Final.pdf"
                    target="_blank"
                  >
                    Terms & Conditions
                  </a>
                </li>
                <li className="footer-text">
                  <a
                    href="https://clapngobucket.s3.amazonaws.com/documents/misc/Privacy+policy+-+Clapingo.pdf"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-md-3 col-sm-3 col-xs-3 mt-4">
              <div className="pull-left">
                <h5 className="heading">Install App</h5>
                <ul className="card-text">
                  <li>
                    <a href="https://clapingo.page.link/install">
                      <img src={`https://images.weserv.nl/?url=${imgUrl}/gplay.png&w=135&h=40&output=webp`} alt="mobile.png" />
                    </a>
                  </li>
                  <li>
                    <a href="https://clapingo.page.link/install">
                      <img src={`https://images.weserv.nl/?url=${imgUrl}/apple.png&w=135&h=40&output=webp`} alt="mobile.png" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <p className="text-white">
              © 2022 Clapingo Education Private Limited{" "}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};


export default Footer;
